"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.addBrandPostfixConditionally = void 0;

var _snakeCase2 = _interopRequireDefault(require("lodash/snakeCase"));

const addBrandPostfixConditionally = (core, postfix) => `${core}${postfix && !postfix.startsWith('template') ? `_${(0, _snakeCase2.default)(postfix)}` : ''}`;

exports.addBrandPostfixConditionally = addBrandPostfixConditionally;